module.exports = __webpack_public_path__ + "static/app-f835ef83a0934570187ec5cbe7d950ef.png";